import { MenuItem } from "./menu.model";

export const MENU: MenuItem[] = [
  // {
  //   label: "Main",
  //   isTitle: true,
  // },
  {
    label: "Home",
    icon: "home",
    link: "/home"
  },
  // {
  //   label: 'Dashboard',
  //   icon: 'grid',
  //   link: '/dashboard'
  // },
  {
    label: "Asset Management",
    icon: "server",
    link: "/things-manager"
  },

  {
    label: "AI Assistant",
    icon: "star",
    link: "/ai-assistant"
  },
  // {
  //   label: 'Maintainance History',
  //   icon: 'file',
  // },
  // {
  //   label: 'Things',
  //   icon: 'cpu',
  //   link: '/things-manager'
  // },
  // {
  //   label: 'Edge Management',
  //   icon: 'codesandbox',
  //   subItems: [
  //     {
  //       label: 'Devices',
  //       link: '/non'
  //     },
  //     {
  //       label: 'Workflows ',
  //       link: '/non'
  //     },

  //   ]
  // },
  // {
  //   label: 'Data Science Studio',
  //   icon: 'cloud-drizzle',
  //   subItems: [
  //     {
  //       label: 'Data Sources',
  //       link: '/non'
  //     },
  //     {
  //       label: 'Data Sets',
  //       link: '/non'
  //     },
  //     {
  //       label: 'Analytics',
  //       link: '/non'
  //     },
  //     {
  //       label: 'Dashboards',
  //       link: '/non'
  //     },
  //     {
  //       label: 'Notebooks',
  //       link: '/non'
  //     },
  //     {
  //       label: 'AI/ML Models',
  //       link: '/non'
  //     },
  //   ]
  // },
  {
    label: "Administration",
    icon: "list",
    subItems: [
      {
        label: "Asset Templates",
        link: "/templates"
      },
      {
        label: "Workspaces",
        link: "/projects"
      },
      {
        label: "Users",
        link: "/users"
      },
      {
        label: "Roles",
        link: "/roles"
      },
      {
        label: "Rules Engine",
        link: "/rules-engine"
      },
      {
        label: "Recipient",
        link: "/reciepint"
      },
      {
        label: "Application Tokens",
        link: "/application-token"
      }
    ]
  }
];
